import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useCallback, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { stopPropagation } from 'src/utils';
import { getBgColor } from 'src/utils/icons';

const BudgetYearAmountCell = (props: GridCellProps) => {
  const {
    isEditMode,
    hasManageBudgetPermission,
    dropDownYearValue,
    hasCanOverrideBudgetsPermission,
    getIsLocked,
  } = useViewCheckbook();
  const { dataItem, dataIndex, field = '', onChange } = props;
  const { value, displayValue } = useGridCellDisplayValue(props);
  const { isDeleted, warnings } = dataItem;
  const handleBudgetChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex,
        dataItem,
        syntheticEvent: e.syntheticEvent,
        field,
        value: e.value === '' ? null : Number(e.value),
      });
    },
    [dataIndex, dataItem, field, onChange]
  );
  const details = getIsLocked({
    field,
    dataItem,
    dropDownYearValue,
  });

  const { index, isLocked, isCurrentPeriodPassed, currentPeriodEditable } = details;
  const isNull = value === null;
  const formattedValue = !isNull ? displayValue : '';

  const editable = useMemo(
    () =>
      !isLocked &&
      isEditMode &&
      !isDeleted &&
      !isCurrentPeriodPassed &&
      hasManageBudgetPermission &&
      currentPeriodEditable &&
      dropDownYearValue
        ? hasCanOverrideBudgetsPermission
          ? true
          : dataItem[`_initialBudgetPeriod${index.toString().padStart(2, '0')}`] === null
        : false,
    [
      currentPeriodEditable,
      dataItem,
      dropDownYearValue,
      hasCanOverrideBudgetsPermission,
      hasManageBudgetPermission,
      index,
      isCurrentPeriodPassed,
      isDeleted,
      isEditMode,
      isLocked,
    ]
  );

  return (
    <GridCellBase
      {...props}
      title={formattedValue}
      className={` ${getBgColor([], warnings?.[field as string])}   
      ${!isEditMode && Number(value) < 0 ? 'budget-cell-color' : ''}
       !text-right`}
      rowSelectionEnabled
    >
      {editable ? (
        <span onClick={stopPropagation}>
          <NumberInput value={!isNull ? value : ''} onChange={handleBudgetChange} prefix="$" />
        </span>
      ) : (
        <span>{formattedValue}</span>
      )}
    </GridCellBase>
  );
};

export default BudgetYearAmountCell;
